'use server';

import { ai } from '@/ai/genkit';
import { z } from 'genkit';

const AnalyzeSoundInputSchema = z.object({
  audioDataUri: z.string(),
});
export type AnalyzeSoundInput = z.infer<typeof AnalyzeSoundInputSchema>;

const AnalyzeSoundOutputSchema = z.object({
  soundDescription: z.string(),
  possibleFaults: z.array(z.string()),
  recommendation: z.string(),
});
export type AnalyzeSoundOutput = z.infer<typeof AnalyzeSoundOutputSchema>;

const audioPrompt = ai.definePrompt({
  name: 'carAudioAnalysis',
  input: { schema: AnalyzeSoundInputSchema },
  output: { schema: AnalyzeSoundOutputSchema },
  // Audio analysis requires multimodal — keep gemini-1.5-flash (supports audio)
  model: 'googleai/gemini-1.5-flash',
  prompt: `خبير ميكانيكا. حلّل صوت السيارة هذا:
{{media url=audioDataUri}}
أعطِ: وصف الصوت، الأعطال المحتملة (قائمة)، توصية عاجلة. باللغة العربية فقط.`,
  config: { maxOutputTokens: 300 },
});

export async function analyzeCarSound(input: AnalyzeSoundInput): Promise<AnalyzeSoundOutput> {
  return analyzeCarSoundFlow(input);
}

const analyzeCarSoundFlow = ai.defineFlow(
  {
    name: 'analyzeCarSoundFlow',
    inputSchema: AnalyzeSoundInputSchema,
    outputSchema: AnalyzeSoundOutputSchema,
  },
  async (input) => {
    const { output } = await audioPrompt(input);
    return output!;
  }
);
